module.exports = __webpack_public_path__ + "static/img/7.2918b18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/7.png
// module id = fd3H
// module chunks = 0